$(function () {

	var showLoading = function () {
		$('#loadingOverlay').show();
	}

	var hideLoading = function () {
		$('#loadingOverlay').hide();
	}

	var showError = function (msg) {
		$('form').prepend('<div class="alert alert-dismissable alert-danger">' + msg + '</div>');
	}

	var hideError = function () {
		$('form .alert').remove();
	}

	var google_id = $('#google_id').val();

	var loadGAPI = function () {
	  gapi.load('auth2', function() {
	    // Ready.
	    $('.google-login-button').click(function (e) {
	      e.preventDefault();
	      showLoading();
	      hideError();
	      gapi.auth2.authorize({
	        client_id: google_id,
	        cookie_policy: 'single_host_origin',
	        scope: 'email profile',
	        response_type: 'code'
	      }, function(response) {
	        if (response && !response.error) {
	          jQuery.ajax({
							type: 'POST',
							url: '/auth/google_oauth2/callback',
							headers: {
        				'X-Requested-With': 'XMLHttpRequest'
      				},
							data: response,
	            success: function(data) {
						    $.ajax({
						      type: 'POST',
						      url: '/portal/google-sign-in',
						      data: data
						    }).done((data) => {
						    	if (data.success) {
						    		window.location.href = data.success
						    	} else {
						    		hideLoading()
						    		showError(I18n.t('google_sign_in_failed'))
						    	}
						    });
	            }
	          });
	        } else {
	          // google authentication failed
	          hideLoading()
	          showError(I18n.t('google_sign_in_failed'))
	        }
	      });
	    });
	  });
	}

	var loadGAPIInterval = setInterval(function () {
    if (typeof gapi !== 'undefined') {
    	clearInterval(loadGAPIInterval);
      loadGAPI();
    }
	}, 100);

})